export function mergeObjects<T>(to: T, from: T): T {
	Object.entries(from)
		.forEach(([k, v]) => {
			// eslint-disable-next-line no-param-reassign
			to[k as keyof T] = v;
		});
	return to;
}

export function isNonEmpty<T>(item: T | null): boolean {
	if (item === null || item === undefined) {
		return false;
	}
	if (typeof item === 'string') {
		return item !== '';
	}
	if (Array.isArray(item)) {
		return item.some(isNonEmpty);
	}
	return Object.values(item).some(isNonEmpty);
}
